import { AppCore } from "./core/AppCore.js";

document.addEventListener("DOMContentLoaded", () => {
    AppCore.init();
});
